import FormHasManySelectField from "./fields/Form/HasManySelect.vue"
import DetailHasManySelectField from "./fields/Detail/HasManySelect.vue"

const hasManySelectFieldSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('form-has-many-select-field', FormHasManySelectField)
    app.component('detail-has-many-select-field', DetailHasManySelectField)

}

export { hasManySelectFieldSetup }